import { interpolatePath } from './linkHelpers';
// PUBLIC API
export const routes = {
    LandingPageRoute: {
        to: "/",
        build: (options) => interpolatePath("/", undefined, options?.search, options?.hash),
    },
    AboutRoute: {
        to: "/about",
        build: (options) => interpolatePath("/about", undefined, options?.search, options?.hash),
    },
    PrivacyPolicyRoute: {
        to: "/privacy",
        build: (options) => interpolatePath("/privacy", undefined, options?.search, options?.hash),
    },
    TermsOfServiceRoute: {
        to: "/terms",
        build: (options) => interpolatePath("/terms", undefined, options?.search, options?.hash),
    },
    ImpressumRoute: {
        to: "/impressum",
        build: (options) => interpolatePath("/impressum", undefined, options?.search, options?.hash),
    },
    LoginRoute: {
        to: "/login",
        build: (options) => interpolatePath("/login", undefined, options?.search, options?.hash),
    },
    SignupRoute: {
        to: "/signup",
        build: (options) => interpolatePath("/signup", undefined, options?.search, options?.hash),
    },
    RequestPasswordResetRoute: {
        to: "/request-password-reset",
        build: (options) => interpolatePath("/request-password-reset", undefined, options?.search, options?.hash),
    },
    PasswordResetRoute: {
        to: "/password-reset",
        build: (options) => interpolatePath("/password-reset", undefined, options?.search, options?.hash),
    },
    EmailVerificationRoute: {
        to: "/email-verification",
        build: (options) => interpolatePath("/email-verification", undefined, options?.search, options?.hash),
    },
    AccountRoute: {
        to: "/account",
        build: (options) => interpolatePath("/account", undefined, options?.search, options?.hash),
    },
    PricingPageRoute: {
        to: "/pricing",
        build: (options) => interpolatePath("/pricing", undefined, options?.search, options?.hash),
    },
    CheckoutRoute: {
        to: "/checkout",
        build: (options) => interpolatePath("/checkout", undefined, options?.search, options?.hash),
    },
    AdminRoute: {
        to: "/admin",
        build: (options) => interpolatePath("/admin", undefined, options?.search, options?.hash),
    },
    AdminAnalyticsRoute: {
        to: "/admin/analytics",
        build: (options) => interpolatePath("/admin/analytics", undefined, options?.search, options?.hash),
    },
    AdminUsersRoute: {
        to: "/admin/users",
        build: (options) => interpolatePath("/admin/users", undefined, options?.search, options?.hash),
    },
    NotFoundRoute: {
        to: "*",
        build: (options) => interpolatePath("*", options.params, options?.search, options?.hash),
    },
    AdminMessagesRoute: {
        to: "/admin/messages",
        build: (options) => interpolatePath("/admin/messages", undefined, options?.search, options?.hash),
    },
    AdminArticlesRoute: {
        to: "/admin/articles",
        build: (options) => interpolatePath("/admin/articles", undefined, options?.search, options?.hash),
    },
    AdminFeedsRoute: {
        to: "/admin/feeds",
        build: (options) => interpolatePath("/admin/feeds", undefined, options?.search, options?.hash),
    },
    FlaggedArticlesRoute: {
        to: "/admin/flagged",
        build: (options) => interpolatePath("/admin/flagged", undefined, options?.search, options?.hash),
    },
    NewsletterRoute: {
        to: "/newsletter",
        build: (options) => interpolatePath("/newsletter", undefined, options?.search, options?.hash),
    },
    NewsletterUnsubscribeRoute: {
        to: "/newsletter/unsubscribe",
        build: (options) => interpolatePath("/newsletter/unsubscribe", undefined, options?.search, options?.hash),
    },
    NewsletterConfirmRoute: {
        to: "/newsletter/confirm",
        build: (options) => interpolatePath("/newsletter/confirm", undefined, options?.search, options?.hash),
    },
    TodayRoute: {
        to: "/today",
        build: (options) => interpolatePath("/today", undefined, options?.search, options?.hash),
    },
    ArticlesRoute: {
        to: "/articles",
        build: (options) => interpolatePath("/articles", undefined, options?.search, options?.hash),
    },
    TrendsRoute: {
        to: "/trends",
        build: (options) => interpolatePath("/trends", undefined, options?.search, options?.hash),
    },
    ActivityRoute: {
        to: "/activity",
        build: (options) => interpolatePath("/activity", undefined, options?.search, options?.hash),
    },
    RecapRoute: {
        to: "/recap",
        build: (options) => interpolatePath("/recap", undefined, options?.search, options?.hash),
    },
    CreateDiscussionRoute: {
        to: "/discussions/create",
        build: (options) => interpolatePath("/discussions/create", undefined, options?.search, options?.hash),
    },
    DiscussionsRoute: {
        to: "/discussions",
        build: (options) => interpolatePath("/discussions", undefined, options?.search, options?.hash),
    },
    DiscussionRoute: {
        to: "/discussions/:discussionId",
        build: (options) => interpolatePath("/discussions/:discussionId", options.params, options?.search, options?.hash),
    },
    ProfileRoute: {
        to: "/u/:username",
        build: (options) => interpolatePath("/u/:username", options.params, options?.search, options?.hash),
    },
};
// PUBLIC API
export { Link } from './Link';
//# sourceMappingURL=index.js.map